import React from "react";

import { HorizontalDivider, VerticalDivider } from "./style";

type DividerProps = {
  vertical?: boolean;
  noMarginBottom?: boolean;
  noMarginTop?: boolean;
  strong?: boolean;
  style?: Record<string, string>;
};

const Divider: React.FC<DividerProps> = ({
  vertical,
  noMarginBottom,
  noMarginTop,
  strong,
  style,
}) => {
  return vertical ? (
    <VerticalDivider strong={strong} data-testid="vertical-divider" style={style} />
  ) : (
    <HorizontalDivider
      data-testid="horizontal-divider"
      noMarginBottom={noMarginBottom}
      noMarginTop={noMarginTop}
      strong={strong}
      style={style}
    />
  );
};

export default React.memo(Divider);
